import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import IntroDuction from '../views/IntroDuction.vue'
import CommuniCation from '../views/CommuniCation.vue'
import Jiansuo from '../components/1'
import Jiehuan from '../components/2'
import Guanyuan from '../components/3'
import SiShisan from '../components/4'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        rootActiveMenu: '/home',
        activeMenu: '/home'
      }
    },
    {
      path: '/introduction',
      name: 'IntroDuction',
      component: IntroDuction,
      redirect: '/introduction/find',
      children: [
        {
          path: 'find',
          component: Jiansuo,
          meta: {
            rootActiveMenu: '/introduction',
            activeMenu: '/find'
          }
        },
        {
          path: 'Jiehuan',
          component: Jiehuan,
          meta: {
            rootActiveMenu: '/introduction',
            activeMenu: '/Jiehuan'
          }
        },
        {
          path: 'Guanyuan',
          component: Guanyuan,
          meta: {
            rootActiveMenu: '/introduction',
            activeMenu: '/Guanyuan'
          }
        },
        {
          path: 'SiShisan',
          component: SiShisan,
          meta: {
            rootActiveMenu: '/introduction',
            activeMenu: '/SiShisan'
          }
        }
      ]
    },
    {
      path: '/communication',
      name: 'CommuniCation',
      component: CommuniCation,
      meta: {
        rootActiveMenu: '/communication',
        activeMenu: '/communication'
      }
    }
  ],
  'mode': 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js